module.exports = "<div class=\"assignments-unassigned__section\">\n  <p class=\"assignments-unassigned__copy\" translate>ASSIGNMENT_UNCONFIRMED_COPY</p>\n  <div class=\"assignments-unassigned__button-bar\">\n    <button class=\"app__button-enabled assignments-unassigned__cancel__button\" ng-click=\"vm.close()\" translate>CANCEL</button>\n    <button class=\"app__button-enabled assignments-unassigned__submit__button\" ng-click=\"vm.confirm()\" translate>CONTINUE</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/assignmentsUnassigned/assignmentsUnassigned.html
// module id = 388
// module chunks = 1